import React from 'react';
import { TimeSlot } from './BookingView';
import { useTranslation } from 'react-i18next';
import { he, enUS } from 'date-fns/locale';
import { format } from 'date-fns';

interface TimeViewProps {
  selectedDate: Date;
  timeSlots: TimeSlot[];
  selectedTime: string | null;
  onTimeSelect: (time: string) => void;
  onContinue: () => void;
}

const TimeView: React.FC<TimeViewProps> = ({ selectedDate, timeSlots, selectedTime, onTimeSelect, onContinue }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'he' ? he : enUS;

  return (
    <div className="p-4">
      <h5>{t('available-times-for')}: {selectedDate && format(selectedDate, 'EEEE, d MMMM yyyy', { locale })} </h5>
      <div className="d-flex flex-wrap gap-2 mb-3 mt-3">
        {timeSlots.map(slot => (
          <button
            key={slot.time}
            className={`btn ${slot.available ? 'btn-outline-primary' : 'btn-outline-secondary'} ${selectedTime === slot.time ? 'active' : ''}`}
            disabled={!slot.available}
            onClick={() => slot.available && onTimeSelect(slot.time)}
          >
            {slot.time}
          </button>
        ))}
      </div>
      <button className="btn btn-primary float-end mb-3" onClick={onContinue} disabled={!selectedTime}>{t('continue')}</button>
    </div>
  );
};

export default TimeView;
